(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-rich-content"]) return;
  try {
    
  (function () {
    const content = document.querySelector('.article-rich #article-content') || document.getElementById('article-content');
    if (!content) return;

    const headings = content.querySelectorAll('h2');
    if (headings.length === 0) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'heading-' + index;
    });

    // Inject inline CTA before 4th H2 heading
    const inlineCtaContent = document.getElementById('inline-cta-content');
    if (inlineCtaContent && headings.length >= 4 && !document.getElementById('inline-cta-injected')) {
      const fourthH2 = headings[3];
      const ctaClone = inlineCtaContent.cloneNode(true);
      ctaClone.id = 'inline-cta-injected';
      ctaClone.classList.remove('hidden');
      fourthH2.parentNode.insertBefore(ctaClone, fourthH2);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    const content = document.getElementById('article-content');
    if (!content) return;

    const headings = content.querySelectorAll('h2');
    if (headings.length === 0) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'heading-' + index;
    });

    // Inject inline CTA before 4th H2 heading
    const inlineCtaContent = document.getElementById('inline-cta-content');
    if (inlineCtaContent && headings.length >= 4) {
      const fourthH2 = headings[3];
      const ctaClone = inlineCtaContent.cloneNode(true);
      ctaClone.id = 'inline-cta-injected';
      ctaClone.classList.remove('hidden');
      fourthH2.parentNode.insertBefore(ctaClone, fourthH2);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-rules"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DAY = 864e5;
  var LABELS = { active: 'Активна', upcoming: 'Предстояща', ended: 'Приключила' };

  function parseDate(s) {
    if (!s) return null;
    var p = s.split('-').map(Number);
    if (p.length !== 3 || p.some(isNaN)) return null;
    return new Date(p[0], p[1] - 1, p[2]);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function days(n) { return n === 1 ? '1 ден' : n + ' дни'; }

  function info(el, today) {
    var start = parseDate(el.getAttribute('data-start'));
    var end = parseDate(el.getAttribute('data-end'));
    var status = 'active', relative = '', progress = null;
    if (start && today < start) {
      status = 'upcoming';
      var n = Math.round((start - today) / DAY);
      relative = n === 1 ? 'Започва утре' : 'Започва след ' + days(n);
    } else if (end && today > end) {
      status = 'ended';
      relative = 'Приключи на ' + fmt(end);
    } else if (end) {
      var left = Math.round((end - today) / DAY);
      relative = left === 0 ? 'Последен ден е днес' : (left === 1 ? 'Остава 1 ден' : 'Остават ' + left + ' дни');
      if (start) progress = Math.min(1, Math.max(0, (today - start + DAY) / (end - start + DAY)));
    } else {
      relative = 'Без крайна дата';
    }
    return { start: start, end: end, status: status, relative: relative, progress: progress };
  }

  function paint(el, data) {
    el.setAttribute('data-status', data.status);
    var pill = el.querySelector('[data-zr-pill]');
    if (pill) { pill.className = 'zr-pill zr-pill--' + data.status; pill.textContent = LABELS[data.status]; }
    var rel = el.querySelector('[data-zr-relative]');
    if (rel) rel.textContent = data.relative;
    var bar = el.querySelector('[data-zr-bar]');
    if (bar) {
      bar.hidden = data.progress === null;
      if (data.progress !== null) bar.firstElementChild.style.width = (data.progress * 100).toFixed(1) + '%';
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-zr-ready')) return;
    root.setAttribute('data-zr-ready', '1');

    var today = new Date(); today.setHours(0, 0, 0, 0);
    var entries = Array.prototype.slice.call(root.querySelectorAll('[data-zr-entry]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-zr-panel]'));
    if (!panels.length) return;
    var panelsWrap = root.querySelector('[data-zr-panels]');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // 1. Recalculate status in the visitor's browser (the server copy may be cached)
    var byId = {};
    entries.forEach(function (entry) {
      var data = info(entry, today);
      entry._zr = data;
      paint(entry, data);
      byId[entry.getAttribute('data-zr-entry')] = entry;
    });
    panels.forEach(function (panel) { paint(panel, info(panel, today)); });

    // 2. Re-group and sort the rail
    var sorters = {
      active: function (a, b) { return (a._zr.end || Infinity) - (b._zr.end || Infinity); },
      upcoming: function (a, b) { return a._zr.start - b._zr.start; },
      ended: function (a, b) { return b._zr.end - a._zr.end; }
    };
    Object.keys(sorters).forEach(function (key) {
      var group = root.querySelector('[data-zr-group="' + key + '"]');
      if (!group) return;
      var list = group.querySelector('[data-zr-list]');
      var mine = entries.filter(function (e) { return e._zr.status === key; }).sort(sorters[key]);
      mine.forEach(function (e) { list.appendChild(e); });
      var count = group.querySelector('[data-zr-count]');
      if (count) count.textContent = mine.length;
      group.hidden = mine.length === 0;
    });

    // 3. Table of contents for a panel
    function buildToc(panel) {
      var body = panel.querySelector('[data-zr-body]');
      var heads = body ? body.querySelectorAll('h2, h3') : [];
      if (!heads.length) return [];
      var hasH2 = body.querySelector('h2');
      var level = hasH2 ? 'H2' : 'H3';
      var out = [];
      Array.prototype.forEach.call(heads, function (h) {
        if (h.tagName !== level) return;
        if (!h.id) h.id = panel.id + '-s' + (out.length + 1);
        out.push({ id: h.id, text: h.textContent.trim() });
      });
      return out;
    }
    function renderToc(target, items) {
      target.innerHTML = '';
      items.forEach(function (it) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + it.id;
        a.textContent = it.text;
        a.setAttribute('data-zr-section', it.id);
        li.appendChild(a);
        target.appendChild(li);
      });
    }

    var current = null;
    var spy = null;

    function select(id, opts) {
      opts = opts || {};
      var panel = document.getElementById(id);
      if (!panel || panels.indexOf(panel) === -1) return false;
      current = panel;
      panels.forEach(function (p) { p.hidden = p !== panel; });
      entries.forEach(function (entry) {
        var on = entry.getAttribute('data-zr-entry') === id;
        var link = entry.querySelector('[data-zr-link]');
        link.setAttribute('aria-current', on ? 'true' : 'false');
        var toc = entry.querySelector('[data-zr-rail-toc]');
        if (toc) toc.hidden = true;
      });

      var items = buildToc(panel);
      var entry = byId[id];
      if (entry) {
        var railToc = entry.querySelector('[data-zr-rail-toc]');
        if (railToc && items.length) { renderToc(railToc.querySelector('ol'), items); railToc.hidden = false; }
        if (entry._zr.status === 'ended') {
          var det = root.querySelector('[data-zr-group="ended"]');
          if (det && det.tagName === 'DETAILS') det.open = true;
        }
      }
      var mtoc = panel.querySelector('[data-zr-mtoc]');
      if (mtoc) {
        mtoc.hidden = !items.length;
        if (items.length) renderToc(mtoc.querySelector('ol'), items);
      }
      watchSections(panel);

      if (opts.updateHash && history.replaceState) history.replaceState(null, '', '#' + id);
      if (opts.scroll) {
        var top = panelsWrap.getBoundingClientRect().top;
        if (top < 0 || window.innerWidth < 900) panelsWrap.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
      return true;
    }

    function watchSections(panel) {
      if (spy) spy.disconnect();
      if (!('IntersectionObserver' in window)) return;
      var links = root.querySelectorAll('[data-zr-section]');
      spy = new IntersectionObserver(function (records) {
        records.forEach(function (r) {
          if (!r.isIntersecting) return;
          Array.prototype.forEach.call(links, function (a) {
            a.setAttribute('aria-current', a.getAttribute('data-zr-section') === r.target.id ? 'true' : 'false');
          });
        });
      }, { rootMargin: '0px 0px -70% 0px' });
      Array.prototype.forEach.call(panel.querySelectorAll('[data-zr-body] h2[id], [data-zr-body] h3[id]'), function (h) { spy.observe(h); });
    }

    function fromHash() {
      var hash = decodeURIComponent((location.hash || '').slice(1));
      if (!hash) return false;
      if (select(hash)) { return true; }
      var target = document.getElementById(hash);
      if (!target) {
        // A section link that is not built yet: "<campaign>-s3"
        var m = hash.match(/^(.*)-s\d+$/);
        if (m && select(m[1])) target = document.getElementById(hash);
      }
      if (target) {
        var owner = target.closest('[data-zr-panel]');
        if (owner) {
          select(owner.id);
          target.scrollIntoView({ block: 'start' });
          return true;
        }
      }
      return false;
    }

    // 4. Events
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-zr-link]');
      if (link) {
        e.preventDefault();
        select(link.closest('[data-zr-entry]').getAttribute('data-zr-entry'), { updateHash: true, scroll: true });
        return;
      }
      var sec = e.target.closest('[data-zr-section]');
      if (sec) {
        var h = document.getElementById(sec.getAttribute('data-zr-section'));
        if (h) {
          e.preventDefault();
          h.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', '#' + h.id);
        }
        return;
      }
      var copy = e.target.closest('[data-zr-copy]');
      if (copy && current) {
        var url = location.origin + location.pathname + '#' + current.id;
        var label = copy.querySelector('span');
        var done = function () {
          var old = label.textContent;
          label.textContent = 'Линкът е копиран';
          setTimeout(function () { label.textContent = old; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Копирайте линка:', url); });
        } else {
          window.prompt('Копирайте линка:', url);
        }
        return;
      }
      if (e.target.closest('[data-zr-print]')) window.print();
    });
    window.addEventListener('hashchange', fromHash);

    // 5. First selection: link in the URL, else the active campaign that ends soonest
    if (!fromHash()) {
      var first = root.querySelector('[data-zr-group="active"]:not([hidden]) [data-zr-entry]') ||
        root.querySelector('[data-zr-group="upcoming"]:not([hidden]) [data-zr-entry]') ||
        root.querySelector('[data-zr-group="ended"]:not([hidden]) [data-zr-entry]');
      if (first) select(first.getAttribute('data-zr-entry'));
    }
    root.classList.add('is-ready');
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zr]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-zr]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-dobri"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-products-dobri-sku-search')) {
    const PAGES_PER_BATCH = 4;
    const MAX_PAGES = 100; // Shopify paginates at most 25,000 products (100 x 250)
    const CACHE_PREFIX = 'featured-products-dobri:';
    const CACHE_TTL = 60 * 60 * 1000; // remember which pages had matches for one hour

    // Finds SKUs past the first 250 products by re-rendering this section with ?page=2, 3, …
    // through the Section Rendering API, a few pages at a time, until every SKU is found.
    class FeaturedProductsDobriSkuSearch extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.controller = new AbortController();
        this.search().catch(() => {});
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      async search() {
        const section = this.closest('.featured-products');
        const list = section?.querySelector('[data-product-list]');
        if (!section || !list) return;

        const totalPages = Math.min(parseInt(this.dataset.totalPages, 10) || 1, MAX_PAGES);
        let missing;
        try {
          missing = new Set(JSON.parse(this.dataset.missing).filter(Boolean));
        } catch (error) {
          missing = new Set();
        }
        if (missing.size === 0 || totalPages < 2) return;

        const designMode = Boolean(window.Shopify && window.Shopify.designMode);
        const cacheKey = CACHE_PREFIX + this.dataset.sectionId + ':' + hash([...missing].sort().join('\n'));
        const cached = designMode ? null : readCache(cacheKey);
        const fetched = new Set();
        const pagesWithMatches = new Set();
        let added = 0;

        const scan = async (pages) => {
          for (let i = 0; i < pages.length && missing.size > 0; i += PAGES_PER_BATCH) {
            const batch = pages.slice(i, i + PAGES_PER_BATCH);
            const results = await Promise.all(batch.map((page) => this.fetchPage(page)));
            if (this.controller.signal.aborted) return;

            results.forEach((result, index) => {
              fetched.add(batch[index]);
              if (!result) return;

              const found = (result.dataset.foundSkus || '').split(',').filter(Boolean);
              found.forEach((sku) => missing.delete(sku));
              if (found.length) pagesWithMatches.add(batch[index]);

              for (const item of [...result.children]) {
                if (isShown(list, item.dataset.productId)) continue;
                insertInOrder(list, item);
                added++;
              }
            });
          }
        };

        // Pages that had matches last time are tried first, so repeat visits usually need one round trip
        if (cached) await scan(cached.pages.filter((page) => page >= 2 && page <= totalPages));

        let scannedAll = false;
        if (missing.size > 0 && !(cached && cached.scannedAll)) {
          const remaining = [];
          for (let page = 2; page <= totalPages; page++) {
            if (!fetched.has(page)) remaining.push(page);
          }
          await scan(remaining);
          scannedAll = missing.size > 0; // only true when the whole catalog was checked
        } else if (cached && cached.scannedAll) {
          scannedAll = true;
        }

        if (this.controller.signal.aborted) return;

        if (added > 0) {
          section.hidden = false;
          if (list.swiper) list.swiper.update();
        }

        if (!designMode) {
          writeCache(cacheKey, { pages: [...pagesWithMatches], scannedAll, t: Date.now() });
        }

        updateEditorNotice(section, missing);
      }

      async fetchPage(page, attempt = 0) {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('page', String(page));

        try {
          const response = await fetch(url, {
            signal: this.controller.signal,
            priority: 'low',
            headers: { Accept: 'text/html' },
          });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return doc.querySelector('[data-sku-scan-results]');
        } catch (error) {
          if (this.controller.signal.aborted) return null;
          if (attempt < 1) return this.fetchPage(page, attempt + 1);
          console.warn('Featured products - Dobri: could not search page ' + page, error);
          return null;
        }
      }
    }

    function isShown(list, productId) {
      return [...list.children].some((el) => el.dataset.productId === productId);
    }

    // SKU matches go after picked products and before collection products, in pasted order
    function insertInOrder(list, item) {
      const position = item.dataset.skuPosition || '';
      const skuItems = [...list.querySelectorAll(':scope > [data-group="sku"]')];
      const nextSkuItem = skuItems.find((el) => (el.dataset.skuPosition || '') > position);
      const firstCollectionItem = list.querySelector(':scope > [data-group="collection"]');
      list.insertBefore(item, nextSkuItem || firstCollectionItem || null);
    }

    function updateEditorNotice(section, missing) {
      const notice = section.querySelector('[data-sku-notice]');
      if (!notice) return;

      if (missing.size === 0) {
        notice.remove();
        return;
      }

      notice.querySelector('[data-sku-notice-status]').textContent = 'SKUs not found:';
      notice.querySelector('[data-sku-notice-list]').textContent = [...missing].join(', ');
      notice.querySelector('[data-sku-notice-help]').hidden = false;
    }

    function hash(text) {
      let value = 5381;
      for (let i = 0; i < text.length; i++) value = ((value << 5) + value + text.charCodeAt(i)) | 0;
      return (value >>> 0).toString(36);
    }

    function readCache(key) {
      try {
        const data = JSON.parse(localStorage.getItem(key));
        if (!data || !Array.isArray(data.pages) || Date.now() - data.t > CACHE_TTL) return null;
        return data;
      } catch (error) {
        return null;
      }
    }

    function writeCache(key, data) {
      try {
        localStorage.setItem(key, JSON.stringify(data));
      } catch (error) {
        // storage full or blocked: the search still works, it just won't remember pages
      }
    }

    customElements.define('featured-products-dobri-sku-search', FeaturedProductsDobriSkuSearch);
  }

  } catch(e) { console.error(e); }
})();
})();
